import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { LocationStore } from '@rivethealth/client/app/location-store.service';
import { AuthService } from '@rivethealth/client/common/auth/auth.service';

@Injectable({ providedIn: 'root' })
export class EmptyRedirectGuard implements CanActivate {
  constructor(
    private readonly locationStore: LocationStore,
    private readonly auth: AuthService,
    private readonly router: Router,
  ) {}

  canActivate(_: ActivatedRouteSnapshot, routerState: RouterStateSnapshot) {
    if (routerState.url === '/') {
      const recentLocation = this.locationStore.get();
      if (recentLocation) {
        this.router.navigateByUrl(recentLocation);
      } else {
        const accountIds = this.auth.getAccountIds();
        if (accountIds && accountIds.length) {
          this.router.navigateByUrl(`/accounts/${accountIds[0]}`);
        } else {
          this.auth.deauthenticate();
          this.router.navigate(['/login']);
        }
      }
      return false;
    } else {
      return true;
    }
  }
}
